<!--<c-footer>-->
<div class="ms-auto">
  TrackOn Inventory
  <span> &copy; 2023</span>
</div>
<!--</c-footer>-->